// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { getExternalProps } from '../internal/utils/external-props';
import InternalDialog from './internal';
export default function Dialog(props) {
    const baseComponentProps = useBaseComponent('Dialog', {
        props: {},
        metadata: {
            hasHeaderActions: Boolean(props.headerActions),
            hasFooter: Boolean(props.footer),
        },
    });
    const externalProps = getExternalProps(props);
    return React.createElement(InternalDialog, { ...externalProps, ...baseComponentProps });
}
applyDisplayName(Dialog, 'Dialog');
//# sourceMappingURL=index.js.map